import { Tabs } from "antd";
import { KeyboardEvent, MouseEvent,  useMemo,  useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Section } from "./section";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { BgFormType } from "@services/guarantees/types";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { isShowPurchase } from "@app/store/purchaseSlice";
import { useAppSelector } from "@app/store/store";
import { LotFields } from "./lotFields";

export type LotsSubComponent = {
  lotIndex: number;
};

export const Lots = () => {
  const classes = useStyles();
  const { control } = useFormContext<BgFormType>();
  const { isStartForm, prefix } = useBgFormContext();
  const isShowPurchaseFields = useAppSelector(isShowPurchase);

  const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";

  const { fields: lots, remove } = useFieldArray({ control, name: currentPrefix });
  const [activeLotTab, setActiveLotTab] = useState("lot-0");

  const tabsItems = useMemo(() => lots.map((lot, idx) => ({
      key: `lot-${idx}`,
      label: lot.lotNumber ? "Лот № " + lot.lotNumber : "Лот",
      children: <LotFields idx={idx} />,
      closable: lots.length > 1,
      // forceRender: true,
  })), [lots, currentPrefix])

  const onEdit = (e: MouseEvent | KeyboardEvent | string, action: "add" | "remove") => {
    if (action === "add") {
      // TODO: до лучших времен
      return;
      // onAddLot();
    } else {
      remove(Number(e) - 1);
      setActiveLotTab(String(lots.length - 1));
    }
  };

  const onChange = (key: string) => {
    setActiveLotTab(key);
  };

  /*const onAddLot = () => {
    append(LOT_MODEL);
    setActiveLotTab(`${lots.length + 1}`);
  };*/

  if (isStartForm && !isShowPurchaseFields) return null;
  return (
    <div>
      <Section>
        <Tabs
          hideAdd
          type="editable-card"
          items={tabsItems}
          activeKey={activeLotTab}
          onChange={onChange}
          onEdit={onEdit}
          className={classes.lotTabs}
        />
      </Section>
    </div>
  );
};
